import { render, staticRenderFns } from "./FileCategories.vue?vue&type=template&id=153b8d66&"
import script from "./FileCategories.vue?vue&type=script&lang=js&"
export * from "./FileCategories.vue?vue&type=script&lang=js&"
import style0 from "./FileCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports